import { Skeleton } from '@mui/material'

const StoreCardSkeleton = () => {
    return (
        <div>
            {[...Array(5)]?.map((_, index) => (
                <Skeleton key={index} variant="rectangular" sx={{ backgroundColor: "lightgray", borderRadius: "10px", marginBottom: "10px" }} width={"100%"} height={100} />
            ))}
        </div>
    )
}

export default StoreCardSkeleton